import { Alert, AlertBody, Heading, TextPassage } from '@petsmart-ui/sparky';
import { useEffect } from 'react';

import { trackBannerAlert } from '@libs/analytics';

const LinkedAutoshipAlert = ({ isFraudValidationNeeded }: { isFraudValidationNeeded: boolean }) => {
    useEffect(() => {
        trackBannerAlert('my account | addresses', 'address linked to autoship');
    }, []);

    return (
        <Alert variant="warning" iconName="exclamation-outline">
            <AlertBody>
                <Heading tagName="h2" size="body-bold">
                    Address linked to Autoship
                </Heading>
                <TextPassage capLinelength={false}>
                    {isFraudValidationNeeded
                        ? 'Changes here won’t affect your Autoship orders'
                        : 'Changing this address will update all associated Autoship orders'}
                </TextPassage>
            </AlertBody>
        </Alert>
    );
};

export default LinkedAutoshipAlert;
